import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FieldsService } from 'src/app/services/fields.service';
import { RolesService } from 'src/app/services/roles.service';
import { ModalConfirmationComponent } from '../modal-confirmation/modal-confirmation.component';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-modal-permission',
  templateUrl: './modal-permission.component.html',
  styleUrls: ['./modal-permission.component.scss'],
})
export class ModalPermissionComponent implements OnInit {
  fields: any[] = [];
  variables: any[] = [];
  data: any[] = [];
  fieldSelected: number = 1;
  isLoaded: boolean = false;
  public id!: number;
  isToastOpen = false;
  isToastOpenDelete = false;

  constructor(
    private modalController: ModalController,
    private fieldService: FieldsService,
    private rolesService: RolesService,
    private loadingService: LoadingService,
    navParams: NavParams
  ) {
    this.id = navParams.get('id');
  }

  ngOnInit() {
    this.getFields();
    this.getVariables();
    this.loadPermissions();
  }

  getFields() {
    this.isLoaded = false;
    this.fieldService.getFields().subscribe((resp) => {
      this.fields = resp;
      this.isLoaded = true;
    });
  }
  getVariables() {
    this.isLoaded = false;
    this.rolesService.getVariables().subscribe((resp) => {
      this.variables = resp;
      this.isLoaded = true;
    });
  }
  loadPermissions() {
    this.isLoaded = false;
    this.loadingService.show();
    this.rolesService.getPermissionsByUserId(this.id).subscribe((data: any) => {
      this.data = data;
      this.loadingService.hide();
      this.isLoaded = true;
    });
  }
  
  checkToggle(fieldId, variableId) {
    const permission = this.data.find((permission) => permission.field.id === fieldId && permission.variable.id === variableId);
    return { isValid: permission ? true : false, id: permission?.id };
  }
  async update(event, field, variable) {
    const permission = this.checkToggle(field, variable)
    const result = await this.openModal(permission.isValid);
    if (result && result.data && result.data.accepted) {
      this.loadingService.show()
      if (!permission.isValid) {
        this.rolesService.updateInformation(field, variable, this.id).subscribe(
          (response) => {
            this.loadPermissions();
            this.loadingService.hide()
            this.isToastOpen = true;
          },
          (error) => { }
        );
        this.isToastOpen = false;
      } else {
        this.rolesService.deletePermissions(permission.id).subscribe(
          (response) => {
            this.loadPermissions();
            this.loadingService.hide()
            this.isToastOpenDelete = true;

          },
          (error) => { }
        );
        this.isToastOpenDelete = false;
      }

    } else {
      event.target.checked = !event.target.checked;
      console.log('El modal fue cerrado sin aceptar');
    }
  }

  async openModal(isValid: boolean): Promise<any> {
    const modal = await this.modalController.create({
      component: ModalConfirmationComponent,
      cssClass: 'modal-class-confimartion',
    });
    modal.present();
    return modal.onDidDismiss();
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
